import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import Text from 'components/Text';
import SimpleModal from 'components/SimpleModal';
import { DescriptionList, Description } from 'components/DescriptionList';
var TypeChangeConfirmationModal = function TypeChangeConfirmationModal(_ref) {
  var name = _ref.name,
    oldType = _ref.oldType,
    newType = _ref.newType,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('modal_confirm_type_change_title'),
    subtitle: name,
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "s"
    }, t('modal_confirm_type_change_message'), /*#__PURE__*/React.createElement(DescriptionList, null, /*#__PURE__*/React.createElement(Description, {
      title: t('form_old_type_colon')
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true
    }, t("file_type_".concat(oldType)))), /*#__PURE__*/React.createElement(Description, {
      title: t('form_new_type_colon')
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true
    }, t("file_type_".concat(newType)))))),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel
    }, {
      label: t('actions_change_type'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onCancel
  });
};
export default TypeChangeConfirmationModal;